export const AuthorizationService = {
    login,
    logout,
    isAuthenticated,
    getUser
};

const REMEMBER_ME_DURATION_SECONDS = 604800; // 7 days
const SESSION_DURATION_SECONDS = 86400; // 24 hours

async function login(email, password, remember_me) {
    const remember = remember_me === true || remember_me === 'true';

    const authRes = await fetch(process.env.REACT_APP_API + '/user/authenticate.php', {
        method: 'POST',
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
    const authJson = await authRes.json();

    if (authJson.status !== 'success') {
        return authJson;
    }

    const userRes = await fetch(
        process.env.REACT_APP_API + '/user/get.php?id=' + authJson.data
    );
    const userJson = await userRes.json();

    if (userJson.status !== 'success') {
        return userJson;
    }

    window.localStorage.setItem('name', userJson.data.firstname);
    window.localStorage.setItem('user', JSON.stringify(userJson.data));
    window.localStorage.setItem('last_login', String(Date.now()));
    window.localStorage.setItem('authenticated', 'true');
    window.localStorage.setItem('remember_me', remember ? 'true' : 'false');

    if (remember) {
        window.localStorage.setItem('email', email);
    } else {
        window.localStorage.removeItem('email');
    }

    return userJson;
}

function isAuthenticated() {
    checkifAuthExpired();

    let user = JSON.parse(window.localStorage.getItem('user'));
    let authenticated = window.localStorage.getItem('authenticated');
    if (user !== null && authenticated !== null) {
        if (user.id !== -1 && authenticated === 'true') {
            return true;
        }
    }
    return false;
}

function getUser() {
    let user = JSON.parse(window.localStorage.getItem('user'));
    if (user !== null && user.id !== -1) {
        return user;
    }
    return null;
}

function checkifAuthExpired() {
    const lastLoginRaw = window.localStorage.getItem('last_login');
    if (!lastLoginRaw) {
        return;
    }

    const lastLogin = parseInt(lastLoginRaw, 10);
    if (Number.isNaN(lastLogin)) {
        return;
    }

    const elapsedSeconds = (Date.now() - lastLogin) / 1000;
    const rememberMe = window.localStorage.getItem('remember_me') === 'true';
    const limit = rememberMe
        ? REMEMBER_ME_DURATION_SECONDS
        : SESSION_DURATION_SECONDS;

    if (elapsedSeconds >= limit) {
        window.localStorage.removeItem('authenticated');
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('last_login');
    }
}

function logout() {
    window.localStorage.removeItem('authenticated');
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('last_login');
}
